import { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@marine/ui/button';
import { Card, CardContent } from '@marine/ui/card';

function ErrorFallback() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background px-6 py-10">
      <Card className="w-full max-w-sm">
        <CardContent className="p-6">
          <div className="flex flex-col items-center gap-3 text-center">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-destructive/10 text-destructive">
              <AlertTriangle className="h-5 w-5" />
            </div>
            <div className="text-sm font-medium">Something went wrong</div>
            <div className="text-xs text-muted-foreground">
              Please refresh the page and try again.
            </div>
            <div className="pt-1">
              <Button onClick={() => window.location.reload()}>Refresh Page</Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
}
